/**
 * Shared list/table toolbar chrome: search field and compact secondary controls.
 * Every control in the toolbar row is 28px tall (Button `sm`, search `h-7`).
 */

/** 28px pill with 13px text, matching Button `sm`. Pair with a size-3.5 search icon at left-2.5. */
export const TABLE_TOOLBAR_SEARCH_INPUT_CLASSNAME =
  "h-7 rounded-full py-0 pl-8 pr-2 text-xs-v4";

/**
 * Export, Filters, and other compact triggers in the table toolbar row.
 * Structural classes only — pair with `variant="secondary" size="sm"` (28px),
 * which supply height, padding, ring, fill, text, and interaction states.
 */
export const TABLE_TOOLBAR_BUTTON_CLASSNAME =
  "group motion-reduce:transition-none";

/**
 * Leading icons from the 18px set, rendered at 14px. The explicit size keeps
 * Button `sm` from shrinking them to its 12px SVG default.
 */
export const TABLE_TOOLBAR_LEADING_ICON_CLASSNAME =
  "size-3.5 shrink-0 text-icon-secondary transition-colors group-hover:text-icon-primary";

/** The search field's leading icon: 14px, vertically centred at left-2.5. */
export const TABLE_TOOLBAR_SEARCH_ICON_CLASSNAME =
  "pointer-events-none absolute top-1/2 left-2.5 size-3.5 -translate-y-1/2 text-icon-tertiary";

/**
 * With `@src/lib/icons/12px/chevron-down`.
 * Important sizing keeps `Button`'s SVG size variants from upscaling the chevron.
 */
export const TABLE_TOOLBAR_CHEVRON_DOWN_ICON_CLASSNAME =
  "!size-2.5 shrink-0 text-icon-secondary transition-colors group-hover:text-icon-primary";
